import {
    CREATE_DISCOUNT_CODE,
    CREATE_DISCOUNT_CODE_FAILURE,
    CREATE_DISCOUNT_CODE_SUCCESS,
} from 'store/actions/types';

export const createDiscountCode = (payload) => {
    return {
        type: CREATE_DISCOUNT_CODE,
        payload: payload,
    };
};

export const createDiscountCodeFailure = (error) => {
    return {
        type: CREATE_DISCOUNT_CODE_FAILURE,
        error: error,
    };
};

export const createDiscountCodeSuccess = (response) => {
    return {
        type: CREATE_DISCOUNT_CODE_SUCCESS,
        id: response.id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/discountCodes/createDiscountCodes.js